export { InfoBanner, type InfoBannerComponentProps } from './InfoBanner';
